
export const TAB = '    ';

export const editorColors = {
    keyword: '#ff79c6',
    builtin: '#4ec9b0',
    string: '#f1fa8c',
    comment: '#6272a4',
    operator: '#000000',
    variable: '#50fa7b',
    className: '#4ec9b0',
    parameter: '#9cdcfe',
    background: '#eeeeee',
    text: '#000000',
    yellow: '#dcdcaa',
    def_color: '#569cd6',
    lineHighlight: '#eeeeee',
    border: '#2c2b2b',
    activeTab: '#202020',
};

export const getFunctionSignature = (taskType) => {
    // Use taskType if needed in future, currently fixed signature
    return `def response_parser(llm_output: str) -> dict:\n`;
};

export const syntaxHighlight = (code) => {
    if (!code) return '';
    return code
        .replace(/(\[|\]|\(|\)|:|\.|=|->)/g, `<span style="color: ${editorColors.operator}">$1</span>`)
        .replace(/\b(List|BaseModel|Optional|dict|int|str|bool|object)\b/g, `<span style="color: ${editorColors.builtin}">$1</span>`)
        .replace(/\b(def|class|return|for|in|False|True)\b/g, `<span style="color: ${editorColors.def_color}">$1</span>`)
        .replace(/\b(LMResponse|ClassificationResponse|EntityRecognitionResponse|NERResponse|GenerationResponse|QAResponse|Entity|Relation)\b/g,
            `<span style="color: ${editorColors.className}">$1</span>`)
        .replace(/\b(Field)\b/g, `<span style="color: ${editorColors.yellow}">$1</span>`)
        .replace(/\b(default|start_index|answer_index|entity_type|is_validated|lm_response|response|labels|entity|extra_params|answer|label|content|source_start_index|target_start_index|entities|relations)\b/g,
            `<span style="color: ${editorColors.parameter}">$1</span>`);
};

export const extractFunctionBody = (functionString) => {
    if (!functionString) {
        return null;
    }
    const lines = functionString.split('\n');
    const bodyLines = lines.slice(1).map((line) => (line.startsWith(TAB) ? line.slice(TAB.length) : line));
    return bodyLines.join('\n');
};

export const getValuesByPath = (value, path) => {
    if (!value || !path) return [];
    const segments = path.split('.').filter(Boolean);
    if (!segments.length) {
        return [value];
    }
    const results = [];
    const traverse = (node, index) => {
        if (node === undefined || node === null) {
            return;
        }
        if (index === segments.length) {
            results.push(node);
            return;
        }
        if (Array.isArray(node)) {
            node.forEach(item => traverse(item, index));
            return;
        }
        if (typeof node === 'object') {
            traverse(node[segments[index]], index + 1);
        }
    };
    traverse(value, 0);
    return results;
};
